import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import Cube from "./Cube";
import { getTestimonialsData } from "../../Services/firebase";
import SectionTitle from "../Common/SectionTitle";
import Loader from "../Loader";

const getBgImg = (idx) => {
  const id = (idx + 1) % 3;
  if (id === 1) {
    return "linear-gradient(to left bottom,#1E293A,#312e81)";
  }
  if (id === 2) {
    return "linear-gradient(to left bottom,rgba(88,28,135,0.5),#a21caf)";
  }
  return "linear-gradient(to left bottom,#1e293b,#1e3a8a)";
};
const Card = ({ data, idx }) => {
  return (
    <Box
      border="1px solid rga(51,65,85)"
      bgImg={getBgImg(idx)}
      minH="360px"
      w="475px"
      padding="1.5rem"
      // textAlign="justify"
      borderRadius="0.5rem"
    >
      <Text color="#CBd5E1" lineHeight="1.6" mb="1rem">
        {data.desc}
      </Text>
      <Text color="#FFF" lineHeight="1.6" fontWeight="bold" fontSize="1.25rem">
        - {data.name}
      </Text>
      <Text color="#fff" lineHeight="1.6" fontWeight="400" fontSize="1.25rem">
        &nbsp; &nbsp;{data.company}
      </Text>
    </Box>
  );
};

const Testimonails = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTestimonialsData = async () => {
    const results = getTestimonialsData();
    setLoading(true);
    results
      .then((res) => {
        setLoading(false);
        setTestimonials(res);
      })
      .catch((err) => {
        setLoading(false);
        setTestimonials([]);
        console.log("error:", err);
      });
  };

  useEffect(() => {
    fetchTestimonialsData();
  }, []);
  const cubeRef = useRef(null);
  useEffect(() => {
    if (cubeRef.current) {
      const timer = setTimeout(() => {
        const canvas = cubeRef.current.getElementsByTagName("canvas");
        if (canvas.length > 1) {
          canvas[1].remove();
        }
      }, [2000]);
      return () => clearTimeout(timer);
    }
  }, [cubeRef]);

  return (
    <Box>
      <SectionTitle title="The Appreciation Wall" />
      <Box
        w="full"
        h="full"
        display="flex"
        justifyContent={{ base: "center", xxl: "flex-start" }}
        alignItems="center"
        flexWrap="wrap"
        gap="1rem"
      >
        {!loading ? (
          testimonials.map((item) => {
            return <Card key={item.id} data={item} />;
          })
        ) : (
          <Loader />
        )}
      </Box>
    </Box>
  );
};

export default Testimonails;
